import { useTranslation } from "react-i18next";
import { ClickToCopyId } from "@/components/common/ClickToCopyId";
import { cn } from "@/lib/utils";

const DEFAULT_SUFFIX_LENGTH = 6;

interface CopyableSerialNumberProps {
  value: string;
  className?: string;
  /** When false, skip the Copy hover hint (Copied! still shows after click). */
  hoverHint?: boolean;
  /** Show only the last N characters (full value is still copied). */
  suffixLength?: number;
}

/** Plain click-to-copy serial; shows a short suffix without truncation chrome. */
export function CopyableSerialNumber({
  value,
  className,
  hoverHint = true,
  suffixLength = DEFAULT_SUFFIX_LENGTH,
}: CopyableSerialNumberProps) {
  const { t } = useTranslation("common");
  const displayValue =
    value.length <= suffixLength ? value : value.slice(-suffixLength);

  return (
    <ClickToCopyId
      value={value}
      displayValue={displayValue}
      variant="plain"
      ellipsis={false}
      hoverHint={hoverHint}
      copyLabel={t("copySerial")}
      className={cn("font-mono tabular-nums", className)}
    />
  );
}
